/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhookEndpointsGet } from "../../funcs/webhookEndpointsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetWebhookEndpointRequest$inboundSchema,
};

export const tool$webhookEndpointsGet: ToolDefinition<typeof args> = {
  name: "webhook-endpoints-get",
  description: `Get Webhook Endpoint

Get a webhook endpoint by its id.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhookEndpointsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
